const _pad = (n) => String(n).padStart(2, "0");

export const getTodayFormatted = () => {
  const d = new Date();
  return `${d.getFullYear()}-${_pad(d.getMonth() + 1)}-${_pad(d.getDate())}`;
};

// Convertit une datetime locale en UTC ISO 8601 avec Z ("2026-06-18T11:05:00Z").
// 1 arg : datetime-local string "YYYY-MM-DDTHH:MM" (ou avec secondes)
// 2 args : date "YYYY-MM-DD" + heure "HH:MM" séparées
// Pour les dates seules, passer timeStr = "00:00".
export const toUTCISOString = (dateOrFull, timeStr) => {
  if (!dateOrFull) return null;
  const full = timeStr !== undefined ? `${dateOrFull}T${timeStr}` : dateOrFull;
  const d = new Date(full);
  if (isNaN(d)) return null;
  return d.toISOString().slice(0, 19) + "Z";
};

// Affiche "DD/MM/YYYY" à partir d'une ISO string ou "YYYY-MM-DD ..."
// Les chaînes date seule (YYYY-MM-DD) sont parsées à midi local pour éviter
// le décalage d'un jour lié à minuit UTC.
export const formatDateShort = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr.includes("T") ? dateStr : `${dateStr}T12:00:00`);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
};
